import { BmHttp } from "../utils/Global";

export const ControllerSoporteByProcedimiento = async (id) => {
    try {
        const response = await BmHttp().get(`soporte/${id}`, {responseType: 'blob'});
        if (response.status === 200) {
            const link = document.createElement('a');
            const blob = response.data;
            const url = URL.createObjectURL(blob);
            link.href = url;
            link.download = `Soporte.zip`;
            link.click();
            return { success: true };
        }else {
            return { success: false };
        }
    } catch (error) {
        return { success: false };
    }
}